import Render from "components/Common/Render";
import React from "react";

interface IPromotionPointsProps {
  heading: string;
  subHeading?: string;
  points: Array<string>;
  customClass?: string;
}

const PromotionPoints: React.FC<IPromotionPointsProps> = ({
  heading,
  subHeading,
  points,
  customClass,
}) => {
  return (
    <div>
      {" "}
      <Render when={!!heading}>
        <h2 className="text-trueBlue text-lg font-semibold">{heading}</h2>
      </Render>
      <Render when={!!subHeading}>
        <p className="text-base text-navyBlue mb-1 font-poppins tracking-wider">
          {subHeading}
        </p>
      </Render>
      <ul
        className={`list-disc list-outside marker:text-navyBlue marker:text-base text-navyBlue text-base ml-8 font-extralight ${customClass}`}
      >
        {points?.map((point: string) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
    </div>
  );
};

export default PromotionPoints;
